import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import Swal from 'sweetalert2';
import mail from "../../../services/mail";
import ModalForm from './Modal'

class DataTable extends Component {

  deleteItem = id => {

    Swal.fire({
      title: 'Você tem certeza?',
      text: 'Excluir o Email definitivamente?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, Exclua!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        const Authorization = 'dRc9HOHgfpJVBEvm5TpwJSqpJ'
      mail.post(`vendaonline/padrao-email/delete`, 
        {id: id }, {headers: { Authorization }}
      )
        .then(response => {
          if (response.data) {
            Swal.fire({
              title: 'Deletado!',
              text: 'Delete com dado do Email.',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.value) {
                window.location.reload();
              }
            })
          }
          
        })
        .catch(err => console.log(err))
      }
  })

  }
  

  render() {
    const data = this.props.data.map(mail => {
      return (
        <tr key={mail.id}>
          <th scope="row">{mail.descricao}</th>
          <td>
          <div className="dropdown show acoes " style={{textAlign: 'center'}}>
              <Link className="btn btn-primary btn-sm dropdown-toggle" to="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fa fa-cog"></i>
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <Link to="#" className="dropdown-item" style={{display: 'inherit'}}>
                <ModalForm className="modal-lg" data={mail} />
                </Link>
                <Link to="#" className="dropdown-item" style={{display: 'inherit', width: '155px'}}>
                  <div>
                    <p className="dropdown-item table-remove" style={{ marginRight: "10px" }} onClick={() => this.deleteItem(mail.id)}> Remover <i className="fa fa-trash-alt"></i></p>
                  </div>
                </Link>
              </div>
            </div>
          </td>
        </tr>
      )
    })

    return (
      <Table className="table table-bordered mb-3">
        <thead>
          <tr>
            <th style={{width: "600px"}}>TIPOS DE MENSAGEM PADRÃO</th>
            <th style={{textAlign: 'center'}}>AÇÕES</th>
          </tr>
        </thead>
        <tbody>
          {data}
        </tbody>
      </Table>
    )
  }
}

export default DataTable